/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateReviewState = /* GraphQL */ `
  mutation UpdateReviewState(
    $auditId: ID!
    $userEmail: String!
    $lastViewed: AWSDateTime
    $completeDate: AWSDateTime
    $state: String
  ) {
    updateReviewState(
      auditId: $auditId
      userEmail: $userEmail
      lastViewed: $lastViewed
      completeDate: $completeDate
      state: $state
    ) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
export const addReviewer = /* GraphQL */ `
  mutation AddReviewer(
    $auditId: ID!
    $userEmail: String!
    $role: String
    $addedDate: String
  ) {
    addReviewer(
      auditId: $auditId
      userEmail: $userEmail
      role: $role
      addedDate: $addedDate
    ) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
export const updateQuestionResponse = /* GraphQL */ `
  mutation UpdateQuestionResponse(
    $questionId: ID!
    $response: String
    $completeDate: String
  ) {
    updateQuestionResponse(
      questionId: $questionId
      response: $response
      completeDate: $completeDate
    ) {
      id
      auditCode
      desc
      result
      notes
      dueDate
      completeDate
      images
      imageData {
        identityId
        imagePath
      }
      response
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createChecklistModel = /* GraphQL */ `
  mutation CreateChecklistModel($input: CreateChecklistModelInput!) {
    createChecklistModel(input: $input) {
      id
      auditCode
      desc
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateChecklistModel = /* GraphQL */ `
  mutation UpdateChecklistModel($input: UpdateChecklistModelInput!) {
    updateChecklistModel(input: $input) {
      id
      auditCode
      desc
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteChecklistModel = /* GraphQL */ `
  mutation DeleteChecklistModel($input: DeleteChecklistModelInput!) {
    deleteChecklistModel(input: $input) {
      id
      auditCode
      desc
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAuditTemplate = /* GraphQL */ `
  mutation CreateAuditTemplate($input: CreateAuditTemplateInput!) {
    createAuditTemplate(input: $input) {
      id
      name
      desc
      checklists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      owner
      ver
      createdAt
      updatedAt
    }
  }
`;
export const updateAuditTemplate = /* GraphQL */ `
  mutation UpdateAuditTemplate($input: UpdateAuditTemplateInput!) {
    updateAuditTemplate(input: $input) {
      id
      name
      desc
      checklists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      owner
      ver
      createdAt
      updatedAt
    }
  }
`;
export const deleteAuditTemplate = /* GraphQL */ `
  mutation DeleteAuditTemplate($input: DeleteAuditTemplateInput!) {
    deleteAuditTemplate(input: $input) {
      id
      name
      desc
      checklists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      owner
      ver
      createdAt
      updatedAt
    }
  }
`;
export const createChecklistTemplate = /* GraphQL */ `
  mutation CreateChecklistTemplate($input: CreateChecklistTemplateInput!) {
    createChecklistTemplate(input: $input) {
      id
      auditCode
      desc
      questions {
        auditCode
        desc
      }
      sublists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      auditTmpl
      parent
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateChecklistTemplate = /* GraphQL */ `
  mutation UpdateChecklistTemplate($input: UpdateChecklistTemplateInput!) {
    updateChecklistTemplate(input: $input) {
      id
      auditCode
      desc
      questions {
        auditCode
        desc
      }
      sublists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      auditTmpl
      parent
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteChecklistTemplate = /* GraphQL */ `
  mutation DeleteChecklistTemplate($input: DeleteChecklistTemplateInput!) {
    deleteChecklistTemplate(input: $input) {
      id
      auditCode
      desc
      questions {
        auditCode
        desc
      }
      sublists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      auditTmpl
      parent
      owner
      createdAt
      updatedAt
    }
  }
`;
export const createErrorLog = /* GraphQL */ `
  mutation CreateErrorLog($input: CreateErrorLogInput!) {
    createErrorLog(input: $input) {
      id
      user
      error
      func
      date
      fullPath
      name
      params
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateErrorLog = /* GraphQL */ `
  mutation UpdateErrorLog($input: UpdateErrorLogInput!) {
    updateErrorLog(input: $input) {
      id
      user
      error
      func
      date
      fullPath
      name
      params
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteErrorLog = /* GraphQL */ `
  mutation DeleteErrorLog($input: DeleteErrorLogInput!) {
    deleteErrorLog(input: $input) {
      id
      user
      error
      func
      date
      fullPath
      name
      params
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createQuestionModel = /* GraphQL */ `
  mutation CreateQuestionModel($input: CreateQuestionModelInput!) {
    createQuestionModel(input: $input) {
      id
      auditCode
      desc
      result
      notes
      dueDate
      completeDate
      images
      imageData {
        identityId
        imagePath
      }
      response
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateQuestionModel = /* GraphQL */ `
  mutation UpdateQuestionModel($input: UpdateQuestionModelInput!) {
    updateQuestionModel(input: $input) {
      id
      auditCode
      desc
      result
      notes
      dueDate
      completeDate
      images
      imageData {
        identityId
        imagePath
      }
      response
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteQuestionModel = /* GraphQL */ `
  mutation DeleteQuestionModel($input: DeleteQuestionModelInput!) {
    deleteQuestionModel(input: $input) {
      id
      auditCode
      desc
      result
      notes
      dueDate
      completeDate
      images
      imageData {
        identityId
        imagePath
      }
      response
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAudit = /* GraphQL */ `
  mutation CreateAudit($input: CreateAuditInput!) {
    createAudit(input: $input) {
      id
      state
      reviewState
      facilityName
      date
      mgrName
      dirEmail
      dirPhone
      mgrEmail
      mgrPhone
      checklists {
        auditCode
        desc
        questions {
          auditCode
          desc
          result
          notes
          dueDate
          image
          images
        }
        sublists {
          auditCode
          desc
        }
      }
      owner
      reviewers
      documents {
        identityId
        file
      }
      archived
      deleted
      failedReview
      totalQs
      inReviewDate
      reviewCompleteDate
      completeDate
      createdAt
      updatedAt
    }
  }
`;
export const updateAudit = /* GraphQL */ `
  mutation UpdateAudit($input: UpdateAuditInput!) {
    updateAudit(input: $input) {
      id
      state
      reviewState
      facilityName
      date
      mgrName
      dirEmail
      dirPhone
      mgrEmail
      mgrPhone
      checklists {
        auditCode
        desc
        questions {
          auditCode
          desc
          result
          notes
          dueDate
          image
          images
        }
        sublists {
          auditCode
          desc
        }
      }
      owner
      reviewers
      documents {
        identityId
        file
      }
      archived
      deleted
      failedReview
      totalQs
      inReviewDate
      reviewCompleteDate
      completeDate
      createdAt
      updatedAt
    }
  }
`;
export const deleteAudit = /* GraphQL */ `
  mutation DeleteAudit($input: DeleteAuditInput!) {
    deleteAudit(input: $input) {
      id
      state
      reviewState
      facilityName
      date
      mgrName
      dirEmail
      dirPhone
      mgrEmail
      mgrPhone
      checklists {
        auditCode
        desc
        questions {
          auditCode
          desc
          result
          notes
          dueDate
          image
          images
        }
        sublists {
          auditCode
          desc
        }
      }
      owner
      reviewers
      documents {
        identityId
        file
      }
      archived
      deleted
      failedReview
      totalQs
      inReviewDate
      reviewCompleteDate
      completeDate
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      owner
      email
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      owner
      email
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      owner
      email
      createdAt
      updatedAt
    }
  }
`;
export const createReviewGroup = /* GraphQL */ `
  mutation CreateReviewGroup($input: CreateReviewGroupInput!) {
    createReviewGroup(input: $input) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
export const updateReviewGroup = /* GraphQL */ `
  mutation UpdateReviewGroup($input: UpdateReviewGroupInput!) {
    updateReviewGroup(input: $input) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
export const deleteReviewGroup = /* GraphQL */ `
  mutation DeleteReviewGroup($input: DeleteReviewGroupInput!) {
    deleteReviewGroup(input: $input) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
